import React, {useMemo} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {CustomFieldValueInput} from '../../../../../components/CustomFieldValueInput';
import {EntityType} from '../../../../admin-tab/custom-fields-page/Constants';

const CustomFieldsSection = ({viewer}) => {
	let {id} = viewer.task;

	const customFieldValues = useMemo(
		() =>
			viewer.task.customFields?.edges
				.map(edge => {
					return {...edge.node};
				})
				.sort((a, b) => (a.displayName > b.displayName ? 1 : -1)) || [],
		[viewer.task.customFields]
	);

	return (
		<div className="task-modal-v3-custom-fields-section-container">
			{customFieldValues.map(customField => {
				return (
					<div key={customField.key} className="task-modal-v3-custom-fields-section">
						<div className="task-modal-v3-custom-fields-section-label">{customField.displayName}</div>

						<CustomFieldValueInput
							customFieldKey={customField.key}
							displayName={customField.displayName}
							value={customField.value}
							entityType={EntityType.TASK}
							entityId={id}
							type={customField.type}
							options={customField.options}
							readOnly={customField.readOnly}
						/>
					</div>
				);
			})}
		</div>
	);
};

export const customFieldsSectionQuery = graphql`
	query customFieldsSection_Query($taskId: ID) {
		viewer {
			actualPersonId
			component(name: "task_custom_field_section")
			...customFieldsSection_viewer @arguments(taskId: $taskId)
		}
	}
`;

export default createFragmentContainer(CustomFieldsSection, {
	viewer: graphql`
		fragment customFieldsSection_viewer on Viewer @argumentDefinitions(taskId: {type: "ID"}) {
			task(id: $taskId) {
				id
				customFields {
					edges {
						node {
							__typename
							id
							key
							value
							type
							displayName
							... on TextCustomFieldValue {
								readOnly
							}
							... on DropdownCustomFieldValue {
								options {
									id
									displayName
								}
							}
						}
					}
				}
			}
		}
	`,
});
